import React from 'react';

export default function QobuzPlaylistRefreshPanel({
  t,
  importing,
  importJoinedInFlight,
  importProgress,
  importResult,
  onRefresh,
}) {
  return (
    <div style={{ borderTop: '1px solid var(--border-light)', paddingTop: 12, marginBottom: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
        <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)' }}>
          {t('qobuz.playlists.title') || 'Qobuz Playlists'}
        </span>
        <button
          type="button"
          onClick={onRefresh}
          disabled={importing}
          style={{
            fontSize: 12, fontWeight: 600, padding: '5px 12px', borderRadius: 6,
            background: 'var(--bg-secondary)', color: 'var(--text-secondary)',
            cursor: importing ? 'wait' : 'pointer', opacity: importing ? 0.6 : 1,
            border: 'none',
          }}
        >{importing ? 'Syncing\u2026' : 'Refresh'}</button>
      </div>
      {importing && importJoinedInFlight && (
        <div style={{ fontSize: 11, color: 'var(--text-tertiary)', lineHeight: 1.45 }}>
          Sync already in progress…
        </div>
      )}
      {importing && importProgress && importProgress.totalFound > 0 && (
        <div style={{ fontSize: 11, color: 'var(--text-tertiary)', lineHeight: 1.45 }}>
          Syncing playlist {Math.min(importProgress.playlistsProcessed, importProgress.totalFound)} of {importProgress.totalFound}…
        </div>
      )}
      {!importing && importResult && importResult.done && (
        <div style={{
          fontSize: 11,
          color: importResult.error ? 'var(--color-error)' : 'var(--text-tertiary)',
          lineHeight: 1.45,
        }}>
          {importResult.error
            ? `${t('qobuz.playlists.error') || 'Import failed.'} ${importResult.error}`
            : (importResult.completionLine
              || t('qobuz.playlists.complete', { added: importResult.imported, updated: importResult.updated })
              || `Added ${importResult.imported}, updated ${importResult.updated}.`)}
        </div>
      )}
    </div>
  );
}
